var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRailFencing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 0.5V2H5.25V0.5H3.75V2H2.25V0.5H0.75V9.5H2.25V8H3.75V9.5H5.25V8H6.75V9.5H8.25V8H9.75V9.5H11.25V8H12.75V9.5H14.25V8H15.75V9.5H17.25V0.5H15.75V2H14.25V0.5H12.75V2H11.25V0.5H9.75V2H8.25V0.5H6.75ZM2.25 3.5H3.75V6.5H2.25V3.5ZM5.25 3.5H6.75V6.5H5.25V3.5ZM8.25 3.5H9.75V6.5H8.25V3.5ZM11.25 3.5H12.75V6.5H11.25V3.5ZM14.25 3.5H15.75V6.5H14.25V3.5Z",
    fill: "#8D1722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailFencing);
export default __webpack_public_path__ + "static/media/railFencing.ebcc423fbffde532f01a7218dcc8885c.svg";
export { ForwardRef as ReactComponent };